import $ from 'jquery';
import ScrollReveal from 'scrollreveal';

window.sr = ScrollReveal({
    duration: 1000,
    origin: 'bottom',
    distance: '15px',
    easing: 'ease',
    scale: 1,
    reset: false,
});

if ($('.reveal').lenght) {
    sr.reveal('.reveal', 250);
}